import {
    mobile,
    backend,
    creator,
    web,
    javascript,
    typescript,
    html,
    css,
    reactjs,
    redux,
    tailwind,
    nodejs,
    mongodb,
    git,
    figma,
    docker,
    // meta,
    funsol,
    infinity,
    mavendevs,
    // starbucks,
    // tesla,
    // shopify,
    carrent,
    jobit,
    tripguide,
    threejs,
  } from "../assets";
  
  export const navLinks = [
    {
      id: "about",
      title: "About",
    },
    {
      id: "work",
      title: "Work",
    },
    {
      id: "contact",
      title: "Contact",
    },
  ];
  
  const services = [
    {
      title: "Web Developer",
      icon: web,
    },
    {
      title: "React Native Developer",
      icon: mobile,
    },
    {
      title: "Backend Developer",
      icon: backend,
    },
    {
      title: "Content Creator",
      icon: creator,
    },
  ];
  
  const technologies = [
    {
      name: "HTML 5",
      icon: html,
    },
    {
      name: "CSS 3",
      icon: css,
    },
    {
      name: "JavaScript",
      icon: javascript,
    },
    {
      name: "TypeScript",
      icon: typescript,
    },
    {
      name: "React JS",
      icon: reactjs,
    },
    {
      name: "Redux Toolkit",
      icon: redux,
    },
    {
      name: "Tailwind CSS",
      icon: tailwind,
    },
    {
      name: "Node JS",
      icon: nodejs,
    },
    {
      name: "MongoDB",
      icon: mongodb,
    },
    {
      name: "Three JS",
      icon: threejs,
    },
    {
      name: "git",
      icon: git,
    },
    {
      name: "figma",
      icon: figma,
    },
    {
      name: "docker",
      icon: docker,
    },
  ];
  
  const experiences = [
  {
      title: "Software Engineer",
      company_name: "Sprint ∞",
      icon: infinity,
      iconBg: "#E6DEDD",
      date: "June 2024 - Present",
      points: [
        "Developed & maintained web applications utilizing NodeJS & React, while leveraging Cloudflare for CDN, DNS, domains & workers.",
        "Built robust APIs, web crawlers, third-party integrations & Websockets utilization for real-time connectivity services to clients.",
        "Enhanced application security with JWT authentication, encryption, RBAC & OAuth 2.0 custom passport strategies.",
        "Built containerized workloads using Docker, LXC, & k3s, utilizing PM2/systemd for process management & Nginx for reverse proxy.",
      ],
    },
     {
      title: "Full Stack Developer",
      company_name: "Funsol (Andromeda)",
      icon: funsol,
      iconBg: "#E6DEDD",
      date: "May 2022 - April 2024",
      points: [
        "Worked in collaboration with designers, developers & devops teams to deliver tier-3 business critical apps, dashboards & architectures.",
        "Delivered scalable backend event-driven systems & Restful APIs in NodeJS, Python & Php for mobile clients (i0S/Android) & frontends.",
        "Worked with both on-premises & cloud servers, configuring firewall, ssh, Nginx for reverse proxy, load balancing, ssl/tls, caching & security",
        "Created scrappers for multiple sites to collect data & manage records, leading to a 50% reduction in manual intervention.",
      ],
    },
    {
      title: "Software Engineer",
      company_name: "Plugify (Mavendevs)",
      icon: mavendevs,
      iconBg: "#E6DEDD",
      date: "Sep 2021 - May 2022",
      points: [
        "Worked across full SDLC, delivering production-ready web apps, websites, custom plugins & extensions.",
        "Contributed in scrum meetings & development workflows, aligning code with CI/CD pipelines, shell scriptings & production support.",
        "Built dashboards & improved system observability by monitoring & logging apps in production.",
        "Delivered & managed applications on cloud platforms, configuring security, ACLs & ssh-based secure server access in linux environments.",
      ],
    },
  
  ];
  
  const testimonials = [
    {
      testimonial:
        "I thought it was impossible to make a website as beautiful as our product, but Rick proved me wrong.",
      name: "Sara Lee",
      designation: "CFO",
      company: "Acme Co",
      image: "https://randomuser.me/api/portraits/women/4.jpg",
    },
    {
      testimonial:
        "I've never met a web developer who truly cares about their clients' success like Rick does.",
      name: "Chris Brown",
      designation: "COO",
      company: "DEF Corp",
      image: "https://randomuser.me/api/portraits/men/5.jpg",
    },
    {
      testimonial:
        "After Rick optimized our website, our traffic increased by 50%. We can't thank them enough!",
      name: "Lisa Wang",
      designation: "CTO",
      company: "456 Enterprises",
      image: "https://randomuser.me/api/portraits/women/6.jpg",
    },
  ];
  
  const projects = [
    {
      name: "Car Rent",
      description:
        "Web-based platform that allows users to search, book, and manage car rentals from various providers, providing a convenient and efficient solution for transportation needs.",
      tags: [
        {
          name: "react",
          color: "blue-text-gradient",
        },
        {
          name: "mongodb",
          color: "green-text-gradient",
        },
        {
          name: "tailwind",
          color: "pink-text-gradient",
        },
      ],
      image: carrent,
      source_code_link: "https://github.com/",
    },
    {
      name: "Job IT",
      description:
        "Web application that enables users to search for job openings, view estimated salary ranges for positions, and locate available jobs based on their current location.",
      tags: [
        {
          name: "react",
          color: "blue-text-gradient",
        },
        {
          name: "restapi",
          color: "green-text-gradient",
        },
        {
          name: "scss",
          color: "pink-text-gradient",
        },
      ],
      image: jobit,
      source_code_link: "https://github.com/",
    },
    {
      name: "Trip Guide",
      description:
        "A comprehensive travel booking platform that allows users to book flights, hotels, and rental cars, and offers curated recommendations for popular destinations.",
      tags: [
        {
          name: "nextjs",
          color: "blue-text-gradient",
        },
        {
          name: "supabase",
          color: "green-text-gradient",
        },
        {
          name: "css",
          color: "pink-text-gradient",
        },
      ],
      image: tripguide,
      source_code_link: "https://github.com/",
    },
  ];
  
  export { services, technologies, experiences, testimonials, projects };
